export const GooglePlayLogo = () => (
  <svg width='23' height='24' viewBox='0 0 23 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <g clipPath='url(#clip0_5242_24495)'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M0.924856 0.368415C0.655066 0.658376 0.5 1.10466 0.5 1.68458V22.3121C0.5 22.8921 0.655066 23.3384 0.934941 23.6182L1.00806 23.68L12.5661 12.1219V11.8622L0.997976 0.306641L0.924856 0.368415Z'
        fill='url(#paint0_linear_5242_24495)'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M16.4114 15.9896L12.5562 12.1331V11.8633L16.4126 8.00684L16.4958 8.05853L21.057 10.6505C22.3631 11.3868 22.3631 12.5996 21.057 13.3459L16.4958 15.9379C16.4946 15.9379 16.4114 15.9896 16.4114 15.9896Z'
        fill='url(#paint1_linear_5242_24495)'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M16.4944 15.9377L12.556 11.998L0.924805 23.6293C1.34966 24.0856 2.06448 24.1373 2.86376 23.691L16.4944 15.9377Z'
        fill='url(#paint2_linear_5242_24495)'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M16.4944 8.06007L2.86376 0.316862C2.06574 -0.139511 1.34966 -0.0777368 0.924805 0.378636L12.5548 11.9985L16.4944 8.06007Z'
        fill='url(#paint3_linear_5242_24495)'
      />
      <path
        opacity='0.2'
        fillRule='evenodd'
        clipRule='evenodd'
        d='M16.4114 15.8545L2.87401 23.546C2.11759 23.981 1.44312 23.9507 1.00818 23.5561L0.935059 23.6292L1.00818 23.691C1.44312 24.0843 2.11759 24.1159 2.87401 23.6809L16.5047 15.9377L16.4114 15.8545Z'
        fill='black'
      />
      <path
        opacity='0.12'
        fillRule='evenodd'
        clipRule='evenodd'
        d='M21.0556 13.2108L16.4011 15.8545L16.4843 15.9377L21.0455 13.3457C21.6986 12.9726 22.0201 12.4859 22.0201 11.998C21.9785 12.4443 21.6469 12.8692 21.0556 13.2108Z'
        fill='black'
      />
      <path
        opacity='0.25'
        fillRule='evenodd'
        clipRule='evenodd'
        d='M2.86381 0.451226L21.0557 10.7864C21.647 11.118 21.9785 11.5529 22.0302 11.9992C22.0302 11.5126 21.7087 11.0247 21.0557 10.6515L2.86381 0.316331C1.55773 -0.430003 0.5 0.191522 0.5 1.68419V1.81908C0.5 0.326417 1.55773 -0.285022 2.86381 0.451226Z'
        fill='white'
      />
    </g>
    <defs>
      <linearGradient
        id='paint0_linear_5242_24495'
        x1='11.5215'
        y1='1.46932'
        x2='-6.97387'
        y2='6.39511'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#00A0FF' />
        <stop offset='0.007' stopColor='#00A1FF' />
        <stop offset='0.26' stopColor='#00BEFF' />
        <stop offset='0.512' stopColor='#00D2FF' />
        <stop offset='0.76' stopColor='#00DFFF' />
        <stop offset='1' stopColor='#00E3FF' />
      </linearGradient>
      <linearGradient
        id='paint1_linear_5242_24495'
        x1='22.7565'
        y1='11.9949'
        x2='0.182557'
        y2='11.9949'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FFE000' />
        <stop offset='0.409' stopColor='#FFBD00' />
        <stop offset='0.775' stopColor='#FFA500' />
        <stop offset='1' stopColor='#FF9C00' />
      </linearGradient>
      <linearGradient
        id='paint2_linear_5242_24495'
        x1='14.3547'
        y1='14.1376'
        x2='-0.52269'
        y2='39.1488'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FF3A44' />
        <stop offset='1' stopColor='#C31162' />
      </linearGradient>
      <linearGradient
        id='paint3_linear_5242_24495'
        x1='-2.00572'
        y1='-6.50115'
        x2='4.63289'
        y2='4.66093'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#32A071' />
        <stop offset='0.069' stopColor='#2DA771' />
        <stop offset='0.476' stopColor='#15CF74' />
        <stop offset='0.801' stopColor='#06E775' />
        <stop offset='1' stopColor='#00F076' />
      </linearGradient>
      <clipPath id='clip0_5242_24495'>
        <rect width='21.9999' height='24' fill='white' transform='translate(0.5)' />
      </clipPath>
    </defs>
  </svg>
);

export const LoginGoogleIcon = () => (
  <svg width='19' height='19' viewBox='0 0 19 19' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M18.14 9.70468C18.14 9.0665 18.0827 8.45286 17.9764 7.86377H9.5V11.3451H14.3436C14.135 12.4701 13.5009 13.4233 12.5477 14.0615V16.3197H15.4564C17.1582 14.7529 18.14 12.4456 18.14 9.70468Z'
      fill='#4285F4'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9.5 18.5C11.93 18.5 13.9673 17.6941 15.4564 16.3195L12.5477 14.0613C11.7418 14.6013 10.7109 14.9204 9.5 14.9204C7.15591 14.9204 5.17182 13.3372 4.46409 11.21H1.45728V13.5418C2.93818 16.4831 5.98182 18.5 9.5 18.5Z'
      fill='#34A853'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M4.46409 11.2098C4.28409 10.6698 4.18182 10.093 4.18182 9.49983C4.18182 8.90664 4.28409 8.32983 4.46409 7.78983V5.45801H1.45727C0.847727 6.67301 0.5 8.04755 0.5 9.49983C0.5 10.9521 0.847727 12.3266 1.45727 13.5416L4.46409 11.2098Z'
      fill='#FBBC05'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9.5 4.07955C10.8214 4.07955 12.0077 4.53364 12.9405 5.42545L15.5218 2.84409C13.9632 1.39182 11.9259 0.5 9.5 0.5C5.98182 0.5 2.93818 2.51682 1.45728 5.45818L4.46409 7.79C5.17182 5.66273 7.15591 4.07955 9.5 4.07955Z'
      fill='#EA4335'
    />
  </svg>
);
